﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireLink = exports.requireScript = void 0;
const requireScript = (src, module = false) => new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
    }
    else {
        const el = document.createElement("script");
        el.src = src;
        el.defer = true;
        if (module) {
            el.type = "module";
        }
        el.addEventListener("load", () => {
            resolve();
        });
        el.addEventListener("error", (ev) => {
            reject(ev);
        });
        document.body.appendChild(el);
    }
});
exports.requireScript = requireScript;
const requireLink = (rel, href, type) => new Promise((resolve, reject) => {
    const tEl = document.querySelector(`script[href="${href}"]`);
    if (tEl && tEl.getAttribute("rel") == rel) {
        resolve();
    }
    else {
        const el = document.createElement("link");
        el.rel = rel;
        el.href = href;
        if (type) {
            el.type = type;
        }
        el.addEventListener("load", () => {
            resolve();
        });
        el.addEventListener("error", (ev) => {
            reject(ev);
        });
        document.body.appendChild(el);
    }
});
exports.requireLink = requireLink;
